import { Deserializable } from './deserializable.model';
import { Icon } from './icon.model';

export class Insight implements Deserializable<any, Insight> {
  constructor(public title?: string, public insight?: string, public icon?: Icon) {}

  deserialize(input: any, existingData?: Insight): Insight {
    if (input == null) {
      return null;
    }

    this.title = input['title'];
    this.insight = input['insight'];

    if (input['icon']) {
      this.icon = new Icon().deserialize(input['icon']);
    }

    return this;
  }
}
